import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Components
// @ts-ignore
import LogoutButton from 'components/LogoutButton';

// Selectors
import {
    makeSelectError,
    makeSelectErrorDetailsMessages
} from 'services/error/selectors';

// Types
import { Namespace, Namespaces } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace | Namespaces;
    displayLogoutButton?: boolean;
    isVisibleOnMount?: boolean;
    style?: React.CSSProperties;
}

interface ConnectedProps {
    header?: string;
    list?: string[];
}

type Props = OwnProps & ConnectedProps;

interface State {
    isVisible: boolean;
}

export class ErrorAlert extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isVisible: !!props.isVisibleOnMount
        };
    }

    // This is done to prevent old error messages from displaying
    componentDidUpdate(): void {
        const { isVisible } = this.state;

        if (!isVisible) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ isVisible: true });
        }
    }

    render(): React.ReactElement | null {
        const { displayLogoutButton, header, list, style } = this.props;
        const { isVisible } = this.state;
        if (!isVisible || !header) {
            return null;
        }
        return (
            <Message style={style} negative>
                <Message.Header>{header}</Message.Header>
                {list && <Message.List items={list} />}
                {displayLogoutButton && <LogoutButton />}
            </Message>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    header: makeSelectError(),
    list: makeSelectErrorDetailsMessages()
});

export default connect(mapStateToProps)(ErrorAlert);
